const nodeTypes = [
  { name: 'Introduction', value: 'Introduction', id: 1 },
  { name: 'Learning moment', value: 'LearningMoment', id: 2 },
  { name: 'Question', value: 'Question', id: 3 },
  { name: 'Restart', value: 'Restart', id: 4 },
  { name: 'Final', value: 'Final', id: 5 },
];
export default nodeTypes;
